import React from 'react'
import ProductItem from './item'
import styles from '../index.less'
import { ItemType } from '../interface'
import { isOdd } from '../utils'
import { ITEM_SCROLL_TIME, ITEM_TRANSITION_TIMING, LOOP_SLIDERS } from '../config'
import SwiperCore, { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperOptions } from 'swiper/types/swiper-options'
import 'swiper/swiper.min.css'

SwiperCore.use([Autoplay])

interface IProps {
  CName: string
  uid: string
  pageId: string
  componentIndex: number
  needScene?: boolean
  productList?: ItemType[]
  componentStyle?: number
  outputBusiness: any
}
const ProductOneLine = (props: IProps) => {
  const { productList = [], needScene, CName, uid, pageId, outputBusiness } = props

  const initStyle = (swiper) => {
    // console.log('online initStyle swiper: ', swiper)
    // swiper.autoplay.stop()
    const imgBoxes = Array.from(swiper.wrapperEl.children || []) as HTMLDivElement[]
    const activeIndex = swiper.activeIndex
    const isCurrentOdd = isOdd(activeIndex) // 判断当前位置是不是奇数
    const currentViewRectIndexList = new Array(LOOP_SLIDERS)
      .fill(activeIndex)
      .map((_, i) => activeIndex + i)
    imgBoxes.length &&
      imgBoxes.forEach((node: HTMLDivElement, index) => {
        if (currentViewRectIndexList.includes(index)) {
          if (isOdd(index)) {
            if (isCurrentOdd) {
              node && node.classList.add(styles.big)
              node && node.classList.remove(styles.small)
            } else {
              node && node.classList.add(styles.small)
              node && node.classList.remove(styles.big)
            }
          } else {
            if (isCurrentOdd) {
              node && node.classList.add(styles.small)
              node && node.classList.remove(styles.big)
            } else {
              node && node.classList.add(styles.big)
              node && node.classList.remove(styles.small)
            }
          }
          const nodeIndex = currentViewRectIndexList.findIndex((i) => i === index)
          const middleIndex = (LOOP_SLIDERS - 1) / 2
          if (nodeIndex < middleIndex) {
            node && node.classList.remove(styles.right)
            node && node.classList.add(styles.left)
          } else if (nodeIndex > middleIndex) {
            node && node.classList.remove(styles.left)
            node && node.classList.add(styles.right)
          }
        } else {
          node && node.classList.remove(styles.small)
          node && node.classList.remove(styles.big)
        }
      })
  }

  const swiperConfig: SwiperOptions = {
    slidesPerView: LOOP_SLIDERS,
    spaceBetween: 0,
    speed: ITEM_TRANSITION_TIMING,
    initialSlide: 1,
    preventClicks: false,
    preventClicksPropagation: false,
    loop: true,
    autoplay: {
      waitForTransition: true,
      delay: ITEM_SCROLL_TIME,
      disableOnInteraction: false,
    },
  }

  return (
    <div className={styles.onelineWrapper}>
      <Swiper {...swiperConfig} onSlideChangeTransitionStart={initStyle}>
        {productList.map((item, index) => {
          return (
            <SwiperSlide className={styles.slider} key={index}>
              <ProductItem
                {...item}
                CName={CName}
                uid={uid}
                pageId={pageId}
                index={index}
                needScene={needScene}
                key={index}
                outputBusiness={outputBusiness}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default ProductOneLine
